/*
 * the Ops-facing IST calendar, shared by every tab. Dates here are IST dates, never the browser's;
 * IST has no DST, so a fixed +05:30 offset is exact.
 */
export const IST_OFFSET_MS = 330 * 60000;
const pad = (n) => String(n).padStart(2, '0');

const ist_parts = (now) => {
  const d = new Date(now.getTime() + IST_OFFSET_MS);
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
};

// The IST calendar date of an instant, as YYYY-MM-DD.
export const ist_day = (now = new Date()) => {
  const p = ist_parts(now);
  return `${p.year}-${pad(p.month)}-${pad(p.day)}`;
};

// The IST pay month of an instant, as YYYY-MM.
export const ist_month_key = (now = new Date()) => {
  const p = ist_parts(now);
  return `${p.year}-${pad(p.month)}`;
};

const HAS_TIME = /\d{1,2}:\d{2}/;
const ENDS_IST = /\bIST\)?$/;

// '2026-07-02 10:15' -> '2026-07-02 10:15 IST'; date-only, empty, '—', non-string and already-labelled pass through.
export const with_ist = (v) => {
  if (typeof v !== 'string') return v;
  const t = v.trim();
  if (!t || !HAS_TIME.test(t) || ENDS_IST.test(t)) return v;
  return `${t} IST`;
};
